export default __webpack_public_path__ + "static/media/create-folder.0b1cda6c.svg";